import GLightbox from 'glightbox'

/**
 * GLightbox für Elemente mit Klasse .glightbox.
 */
export function lightbox() {
	if (!document.querySelector('.glightbox')) return

	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: false,
		openEffect: 'fade',
		closeEffect: 'fade'
	})
}
